import React from "react";
import { Link } from "react-router-dom";
import { BookOpen, Heart } from "lucide-react";

export function Footer() {
    return (
        <footer className="border-t border-border bg-paper mt-24">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid md:grid-cols-3 gap-10">
                <div>
                    <div className="flex items-center gap-2 mb-3">
                        <BookOpen className="text-primary" size={20} />
                        <span className="font-serif text-xl font-semibold">Incipit</span>
                    </div>
                    <p className="text-sm text-muted-foreground max-w-xs leading-relaxed">
                        Editoria libera. La piattaforma indipendente e gratuita che unisce scrittori emergenti ed editor freelance.
                    </p>
                </div>
                <div>
                    <h4 className="text-xs uppercase tracking-[0.2em] font-medium text-muted-foreground mb-4">Naviga</h4>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/editors" className="hover:text-primary transition-colors">Trova un editor</Link></li>
                        <li><Link to="/auth?mode=register" className="hover:text-primary transition-colors">Diventa editor</Link></li>
                        <li><Link to="/#come-funziona" className="hover:text-primary transition-colors">Come funziona</Link></li>
                        <li><Link to="/privacy" className="hover:text-primary transition-colors">Informativa Privacy</Link></li>
                        <li><Link to="/cookie" className="hover:text-primary transition-colors">Cookie Policy</Link></li>
                    </ul>
                </div>
                <div>
                    <h4 className="text-xs uppercase tracking-[0.2em] font-medium text-muted-foreground mb-4">Il nostro impegno</h4>
                    <p className="text-sm text-muted-foreground leading-relaxed flex items-start gap-2">
                        <Heart size={16} className="text-primary mt-0.5 shrink-0" />
                        100% gratuito per scrittori ed editor. Nessun business, solo un servizio per la comunità letteraria.
                    </p>
                </div>
            </div>
            <div className="border-t border-border py-6 text-center text-xs text-muted-foreground">
                © {new Date().getFullYear()} Incipit — Editoria Libera. Un progetto no-profit.
            </div>
        </footer>
    );
}
